'use client'

import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-LightItalic.ttf') format('truetype');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-RegularItalic.ttf') format('truetype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-MediumItalic.ttf') format('truetype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-Semibold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-SemiboldItalic.ttf') format('truetype');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-Bold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-BoldItalic.ttf') format('truetype');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-Heavy.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SF Pro Text';
    src: url('/fonts/SFProText-HeavyItalic.ttf') format('truetype');
    font-weight: 800;
    font-style: italic;
    font-display: swap;
  }

  body {
    font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    letter-spacing: 0.05px !important;
  }
  
  #root {
    height: 100%;
    width: 100%;
  }

  body {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  input, textarea {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  [contenteditable] {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  p {
    margin: 0;
  }

  .modal-wrapper { 
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    height: 100%;
  }

   .sign-up-modal-wrapper {
    background: url('/images/signUpBg.svg') no-repeat center center;
  }

   .forgot-pass-modal-wrapper {
    background: url('/images/forgotPassBg.svg') no-repeat center center;
  }
    .sign-in-modal-wrapper {
    background: url('/images/signInBg.svg') no-repeat center center;
  }

  img[src*="/icons/"],
  img[src*="/images/"],
  svg {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    pointer-events: auto;
  }

  /* ANT DESIGN MODAL ANIMATION FOR SLIDE UP */

  @keyframes antSlideUp {
    0% {
      transform: translateY(100%);
      transformorigin: 0% 0%;
      /* opacity: 0; */
    }

    100% {
      transform: translateY(0);
      transformorigin: 0% 0%;
      /* opacity: 1; */
    }
  }

  @keyframes antSlideOut {
    0% {
      transform: translateY(0);
      transformorigin: 0% 0%;
      /* opacity: 1; */
    }

    100% {
      transform: translateY(100%);
      transformorigin: 0% 0%;
      /* opacity: 0; */
    }
  }

  .ant-modal-slide-up-enter,
  .ant-modal-slide-up-appear {
    transform: scale(0);
    transform-origin: 0% 0%;
    /* opacity: 0; */
    animation-play-state: paused;
    animation-duration: 0.60s;
    animation-fill-mode: both;
  }

  .ant-modal-slide-up-leave {
    animation-play-state: paused;
    animation-duration: 0.60s;
    animation-fill-mode: both;
  }

  .ant-modal-slide-up-enter.ant-modal-slide-up-enter-active,
  .ant-modal-slide-up-appear.ant-modal-slide-up-appear-active {
    animation-name: antSlideUp;
    animation-play-state: running;
  }

  .ant-modal-slide-up-leave.ant-modal-slide-up-leave-active {
    animation-name: antSlideOut;
    animation-play-state: running;
    pointer-events: none;
  }

  *:focus-visible {
    outline: none !important;
  }

  .ant-btn,
  .ant-btn:focus,
  .ant-btn:active,
  .ant-btn:hover,
  .ant-btn:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
`
